const getJson = (arr, obj, value = 0) => {
    return arr.reduce((a, b) => a && a[b] ? a[b] : value, obj)
}

export default getJson


// WEBPACK FOOTER //
// ./src/method/getJson.js